import React, { useContext } from 'react'
import { useCurrentExpert } from '../shared/customHooks/useCurrentExpert'

export const OnboardingContext = React.createContext()
export const useOnboarding = () => useContext(OnboardingContext)

export const OnboardingProvider = ({ children }) => {
  const { currentExpert } = useCurrentExpert()

  return <>{currentExpert}</>
}
